import validate from "/app/node_modules/.pnpm/nuxt@3.8.1_@types+node@18.17.12_eslint@8.53.0_typescript@5.2.2_vite@4.5.0_vue-tsc@1.8.22/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.8.1_@types+node@18.17.12_eslint@8.53.0_typescript@5.2.2_vite@4.5.0_vue-tsc@1.8.22/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}